"use client";

import * as Sentry from "@sentry/nextjs";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // The locale layout stays mounted around a segment error, so the intl context
  // is available here — the strings used to be hard-coded Russian, which showed
  // to every English visitor including getmintai.app.
  const t = useTranslations("common");

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 font-sans">
      <h2 className="text-xl font-semibold">{t("somethingWentWrong")}</h2>
      <button
        onClick={reset}
        className="cursor-pointer rounded-lg bg-[#5B4CFF] px-6 py-2 text-white hover:opacity-90"
      >
        {t("retry")}
      </button>
    </div>
  );
}
